<template>
  <div class="btn-group float-end" role="group">
    <slot></slot>
  </div>
</template>